export interface IHistogeneticsOrders {

    id: number;
    entityType: string;
    orderType: string;
    status: string;
    alias: string;
    firstName: string;
    lastName: string;
    orderDate: string;
    dateReceived: string;
    resultsDate: string;

}


